var React = require('react');

function FailedActivity (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .failed-activity-svg {\n        fill: #bbb;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"className":"failed-activity-svg","d":"M1346,211a6,6,0,1,1-6,6A6,6,0,0,1,1346,211Zm-1,2h2v6h-2v-6Zm0,7h2v1h-2v-1Z","transform":"translate(-1340 -211)","key":1})]);
}

FailedActivity.defaultProps = {"width":"10","height":"10","viewBox":"0 0 12 12"};

module.exports = FailedActivity;

FailedActivity.default = FailedActivity;
